import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { MouseEventHandler, ReactNode } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import Collapse from '@mui/material/Collapse';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CloseIcon from '@mui/icons-material/Close';
import { translate } from '@openclassrooms/translations';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { styled } from '@classify/react-core-components/styles';
import Divider from '@classify/react-core-components/Divider';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import useMainNavigation from '../../../hooks/useMainNavigation';
import MainHeaderLogo from '../MainHeaderLogo';
import StyledListItem from './StyledListItem';
import StyledListItemText from './StyledListItemText';
import LinkListItem from './LinkListItem';
import OverTitleListItem from './StyledOverTitle';
interface Props {
  additionalMenu?: ReactNode;
}
const StyledDivider = styled(Divider)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  '&&': {
    backgroundColor: palette.background.alternative
  },
  marginLeft: spacing(2),
  marginRight: spacing(2)
}));
const MainHeaderDrawer = t0 => {
  const $ = _c(105);
  const {
    additionalMenu
  } = t0;
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isTrainingMenuOpen, setIsTrainingMenuOpen] = useState(false);
  const [isApprenticeshipMenuOpen, setIsApprenticeshipMenuOpen] = useState(false);
  const [isBusinessMenuOpen, setIsBusinessMenuOpen] = useState(false);
  const navigationConfig = useMainNavigation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsTrainingMenuOpen(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleToggleTrainingMenu = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsApprenticeshipMenuOpen(_temp2);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleToggleApprenticeshipMenu = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsBusinessMenuOpen(_temp3);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleToggleBusinessMenu = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsDrawerOpen(false);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleLinkClick = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event => {
      if (event.defaultPrevented || event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
        return;
      }
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      const link = target.closest("a[href]");
      if (link && event.currentTarget.contains(link)) {
        handleLinkClick();
      }
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleAdditionalMenuClick = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      "& .MuiDrawer-paper": {
        width: {
          sx: 264,
          sm: 350
        }
      }
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsDrawerOpen(false);
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: "flex",
      direction: "row",
      alignItems: "center"
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setIsDrawerOpen(false);
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      display: "block",
      color: "palette.text.onMain",
      marginLeft: 0.5,
      marginRight: 1
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Box sx={t8}><IconButton aria-label="close" onClick={t9} size="large" sx={t10}><CloseIcon sx={{
          display: "block"
        }} aria-label="close" /></IconButton><MainHeaderLogo /></Box>;
    t12 = <Divider />;
    $[10] = t11;
    $[11] = t12;
  } else {
    t11 = $[10];
    t12 = $[11];
  }
  let t13;
  if ($[12] !== additionalMenu) {
    t13 = additionalMenu && <><Box sx={{
        my: 2
      }} onClickCapture={handleAdditionalMenuClick}>{additionalMenu}</Box><Divider /></>;
    $[12] = additionalMenu;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const t14 = isTrainingMenuOpen ? 0 : null;
  let t15;
  if ($[14] !== t14) {
    t15 = {
      mb: t14
    };
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  const t16 = isTrainingMenuOpen ? "subheading" : "body";
  let t17;
  if ($[16] !== navigationConfig.TRAINING.content || $[17] !== t16) {
    t17 = <StyledListItemText primary={<Typography variant={t16} component="span">{navigationConfig.TRAINING.content}</Typography>} />;
    $[16] = navigationConfig.TRAINING.content;
    $[17] = t16;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== isTrainingMenuOpen) {
    t18 = isTrainingMenuOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
    $[19] = isTrainingMenuOpen;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] !== t15 || $[22] !== t17 || $[23] !== t18) {
    t19 = <StyledListItem onClick={handleToggleTrainingMenu} sx={t15}>{t17}{t18}</StyledListItem>;
    $[21] = t15;
    $[22] = t17;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = translate("global.word.reduce");
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      pl: 2
    };
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== navigationConfig.OFFERS) {
    t22 = <LinkListItem link={navigationConfig.OFFERS} isSubMenuItem={true} onClickAction={handleLinkClick} />;
    $[27] = navigationConfig.OFFERS;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <OverTitleListItem>{translate("main_header.training_programs.dropdown.paths.overline")}</OverTitleListItem>;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== navigationConfig.PATHS) {
    t24 = <LinkListItem link={navigationConfig.PATHS} isSubMenuItem={true} onClickAction={handleLinkClick} />;
    $[30] = navigationConfig.PATHS;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <OverTitleListItem>{translate("main_header.training_programs.dropdown.courses.overline")}</OverTitleListItem>;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] !== navigationConfig.COURSES) {
    t26 = <LinkListItem link={navigationConfig.COURSES} isSubMenuItem={true} onClickAction={handleLinkClick} />;
    $[33] = navigationConfig.COURSES;
    $[34] = t26;
  } else {
    t26 = $[34];
  }
  let t27;
  if ($[35] !== t22 || $[36] !== t24 || $[37] !== t26) {
    t27 = <List component="div" disablePadding={true} sx={t21}>{t22}{t23}{t24}{t25}{t26}</List>;
    $[35] = t22;
    $[36] = t24;
    $[37] = t26;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  let t28;
  if ($[39] !== isTrainingMenuOpen || $[40] !== t27) {
    t28 = <Collapse in={isTrainingMenuOpen} timeout="auto" unmountOnExit={true} aria-label={t20}>{t27}</Collapse>;
    $[39] = isTrainingMenuOpen;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== getLocalisationConfig || $[43] !== isApprenticeshipMenuOpen || $[44] !== navigationConfig.APPRENTICESHIP.content || $[45] !== navigationConfig.APPRENTICESHIP.shouldBeDisplayed || $[46] !== navigationConfig.BECOME_AN_APPRENTICE || $[47] !== navigationConfig.CONSULT_JOB_OFFERS || $[48] !== navigationConfig.FINALIZE_APPRENTICESHIP || $[49] !== navigationConfig.RECRUIT_APPRENTICES) {
    t29 = navigationConfig.APPRENTICESHIP.shouldBeDisplayed && <><StyledListItem onClick={handleToggleApprenticeshipMenu} sx={{
        mb: isApprenticeshipMenuOpen ? 0 : null
      }}><StyledListItemText primary={<Typography variant={isApprenticeshipMenuOpen ? "subheading" : "body"} component="span">{navigationConfig.APPRENTICESHIP.content}</Typography>} />{isApprenticeshipMenuOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</StyledListItem><Collapse in={isApprenticeshipMenuOpen} timeout="auto" unmountOnExit={true} aria-label={translate("global.word.reduce")}><List component="div" disablePadding={true} sx={{
          pl: 2
        }}><OverTitleListItem>{translate("main_header.apprenticeship_dropdown.b2c.overline")}</OverTitleListItem><LinkListItem link={navigationConfig.BECOME_AN_APPRENTICE} isSubMenuItem={true} onClickAction={handleLinkClick} /><LinkListItem link={navigationConfig.CONSULT_JOB_OFFERS} isSubMenuItem={true} onClickAction={handleLinkClick} /><OverTitleListItem>{translate("main_header.apprenticeship_dropdown.business.overline")}</OverTitleListItem><LinkListItem link={navigationConfig.RECRUIT_APPRENTICES} isSubMenuItem={true} onClickAction={handleLinkClick} />{getLocalisationConfig("apprenticeship.hasTalentPool") && <LinkListItem link={navigationConfig.FINALIZE_APPRENTICESHIP} isSubMenuItem={true} onClickAction={handleLinkClick} />}</List></Collapse></>;
    $[42] = getLocalisationConfig;
    $[43] = isApprenticeshipMenuOpen;
    $[44] = navigationConfig.APPRENTICESHIP.content;
    $[45] = navigationConfig.APPRENTICESHIP.shouldBeDisplayed;
    $[46] = navigationConfig.BECOME_AN_APPRENTICE;
    $[47] = navigationConfig.CONSULT_JOB_OFFERS;
    $[48] = navigationConfig.FINALIZE_APPRENTICESHIP;
    $[49] = navigationConfig.RECRUIT_APPRENTICES;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== navigationConfig.FUNDING) {
    t30 = navigationConfig.FUNDING.shouldBeDisplayed && <LinkListItem link={navigationConfig.FUNDING} onClickAction={handleLinkClick} />;
    $[51] = navigationConfig.FUNDING;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <StyledDivider />;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  const t32 = isBusinessMenuOpen ? 0 : null;
  let t33;
  if ($[54] !== t32) {
    t33 = {
      mb: t32
    };
    $[54] = t32;
    $[55] = t33;
  } else {
    t33 = $[55];
  }
  const t34 = isBusinessMenuOpen ? "subheading" : "body";
  let t35;
  if ($[56] !== navigationConfig.BUSINESS.content || $[57] !== t34) {
    t35 = <StyledListItemText primary={<Typography variant={t34} component="span">{navigationConfig.BUSINESS.content}</Typography>} />;
    $[56] = navigationConfig.BUSINESS.content;
    $[57] = t34;
    $[58] = t35;
  } else {
    t35 = $[58];
  }
  let t36;
  if ($[59] !== isBusinessMenuOpen) {
    t36 = isBusinessMenuOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
    $[59] = isBusinessMenuOpen;
    $[60] = t36;
  } else {
    t36 = $[60];
  }
  let t37;
  if ($[61] !== t33 || $[62] !== t35 || $[63] !== t36) {
    t37 = <StyledListItem onClick={handleToggleBusinessMenu} sx={t33}>{t35}{t36}</StyledListItem>;
    $[61] = t33;
    $[62] = t35;
    $[63] = t36;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  let t38;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = translate("global.word.reduce");
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  let t39;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = {
      pl: 2
    };
    $[66] = t39;
  } else {
    t39 = $[66];
  }
  let t40;
  if ($[67] !== navigationConfig.BUSINESS_DISCOVER) {
    t40 = <LinkListItem link={navigationConfig.BUSINESS_DISCOVER} isSubMenuItem={true} onClickAction={handleLinkClick} />;
    $[67] = navigationConfig.BUSINESS_DISCOVER;
    $[68] = t40;
  } else {
    t40 = $[68];
  }
  let t41;
  if ($[69] !== getLocalisationConfig || $[70] !== navigationConfig.FINALIZE_APPRENTICESHIP || $[71] !== navigationConfig.UPLIFT) {
    t41 = getLocalisationConfig("page.uplift.url") && <><OverTitleListItem>{translate("main_header.business_dropdown.recruitment.overline")}</OverTitleListItem><LinkListItem link={navigationConfig.UPLIFT} isSubMenuItem={true} onClickAction={handleLinkClick} />{getLocalisationConfig("apprenticeship.hasTalentPool") && <LinkListItem link={navigationConfig.FINALIZE_APPRENTICESHIP} isSubMenuItem={true} onClickAction={handleLinkClick} />}</>;
    $[69] = getLocalisationConfig;
    $[70] = navigationConfig.FINALIZE_APPRENTICESHIP;
    $[71] = navigationConfig.UPLIFT;
    $[72] = t41;
  } else {
    t41 = $[72];
  }
  let t42;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <OverTitleListItem>{translate("main_header.business_dropdown.train.overline")}</OverTitleListItem>;
    $[73] = t42;
  } else {
    t42 = $[73];
  }
  let t43;
  if ($[74] !== navigationConfig.SPARK) {
    t43 = <LinkListItem link={navigationConfig.SPARK} isSubMenuItem={true} onClickAction={handleLinkClick} />;
    $[74] = navigationConfig.SPARK;
    $[75] = t43;
  } else {
    t43 = $[75];
  }
  let t44;
  if ($[76] !== navigationConfig.BOOST) {
    t44 = <LinkListItem link={navigationConfig.BOOST} isSubMenuItem={true} onClickAction={handleLinkClick} />;
    $[76] = navigationConfig.BOOST;
    $[77] = t44;
  } else {
    t44 = $[77];
  }
  let t45;
  if ($[78] !== navigationConfig.PIVOT) {
    t45 = <LinkListItem link={navigationConfig.PIVOT} isSubMenuItem={true} onClickAction={handleLinkClick} />;
    $[78] = navigationConfig.PIVOT;
    $[79] = t45;
  } else {
    t45 = $[79];
  }
  let t46;
  if ($[80] !== t40 || $[81] !== t41 || $[82] !== t43 || $[83] !== t44 || $[84] !== t45) {
    t46 = <List component="div" disablePadding={true} sx={t39}>{t40}{t41}{t42}{t43}{t44}{t45}</List>;
    $[80] = t40;
    $[81] = t41;
    $[82] = t43;
    $[83] = t44;
    $[84] = t45;
    $[85] = t46;
  } else {
    t46 = $[85];
  }
  let t47;
  if ($[86] !== isBusinessMenuOpen || $[87] !== t46) {
    t47 = <Collapse in={isBusinessMenuOpen} timeout="auto" unmountOnExit={true} aria-label={t38}>{t46}</Collapse>;
    $[86] = isBusinessMenuOpen;
    $[87] = t46;
    $[88] = t47;
  } else {
    t47 = $[88];
  }
  let t48;
  if ($[89] !== t19 || $[90] !== t28 || $[91] !== t29 || $[92] !== t30 || $[93] !== t37 || $[94] !== t47) {
    t48 = <List component="nav">{t19}{t28}{t29}{t30}{t31}{t37}{t47}</List>;
    $[89] = t19;
    $[90] = t28;
    $[91] = t29;
    $[92] = t30;
    $[93] = t37;
    $[94] = t47;
    $[95] = t48;
  } else {
    t48 = $[95];
  }
  let t49;
  if ($[96] !== isDrawerOpen || $[97] !== t13 || $[98] !== t48) {
    t49 = <Drawer sx={t6} open={isDrawerOpen} onClose={t7}>{t11}{t12}{t13}{t48}</Drawer>;
    $[96] = isDrawerOpen;
    $[97] = t13;
    $[98] = t48;
    $[99] = t49;
  } else {
    t49 = $[99];
  }
  let t50;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = () => {
      setIsDrawerOpen(true);
    };
    $[100] = t50;
  } else {
    t50 = $[100];
  }
  let t51;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      display: {
        xs: "block",
        md: "none"
      },
      marginRight: 1,
      color: "palette.text.onMain",
      marginLeft: -1.5
    };
    $[101] = t51;
  } else {
    t51 = $[101];
  }
  let t52;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <IconButton aria-label="menu" onClick={t50} size="large" sx={t51}><MenuIcon aria-label={translate("global.word.menu")} sx={{
        display: "block"
      }} /></IconButton>;
    $[102] = t52;
  } else {
    t52 = $[102];
  }
  let t53;
  if ($[103] !== t49) {
    t53 = <>{t49}{t52}</>;
    $[103] = t49;
    $[104] = t53;
  } else {
    t53 = $[104];
  }
  return t53;
};
export default MainHeaderDrawer;
function _temp(prev) {
  return !prev;
}
function _temp2(prev_0) {
  return !prev_0;
}
function _temp3(prev_1) {
  return !prev_1;
}